import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { toast } from 'react-toastify';
import { deleteState } from "../../APIs/SettingRequests";


export default function StatesTableComponent({ thead, tbody, refreshPage }) {

    const [data, setData] = useState([]);
    const { t } = useContext(TranslatorContext);

    useEffect(()=> { setData(tbody) }, [tbody]);

    const handleDelete = (item) => {
                deleteState(item.id).then((res) => {
                    //console.log(res.data.data);
                    const notify = () => toast.success(res.data.message);
                    notify();
                    refreshPage();
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                });
            }
    return (
        <div className="mc-table-responsive">
            <table className="mc-table">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead.map((item, index) => (
                            <th key={ index }>{ item }</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data?.map((item, index) => (
                        <tr key={ index }> 
                            <td title={ item.id }>
                                <div className="mc-table-profile">
                                    <p>{t(item.id) }</p>
                                </div>
                            </td>
                            <td title={ item.name }>{ item.name }</td>
                           <td>
                                <div className="mc-table-action">
                                    {/* <ButtonComponent title="Delete" className="material-icons delete" onClick={() => handleDelete(item)}>{ "delete" }</ButtonComponent> */}
                                
                                </div>
                            </td>
                            
                        </tr>
                    ))}
                </tbody>
            </table>
            
        </div>
    )
}